import React from 'react'
import classNames from 'classnames'
import router from 'next/router'

import { Button } from 'components/common/Buttons/Button'
import { Container, FlexRow } from 'components/common/Containers'
import Input from 'components/common/Input/Input'
import { Select } from 'components/common/Select'

import { notificationController } from 'notificationController/notificationController'
import { RouteEnum } from 'enums/RouteEnum'
import { useGetUser } from 'hooks/useGetUser'

import styles from './TopFilter.module.scss'

const limitOptions = [
  {
    label: '5',
    value: '5',
  },
  {
    label: '10',
    value: '10',
  },
  {
    label: '15',
    value: '15',
  },
  {
    label: '20',
    value: '20',
  },
  {
    label: '25',
    value: '25',
  },
  {
    label: '50',
    value: '50',
  },
  {
    label: '100',
    value: '100',
  },
  {
    label: '200',
    value: '200',
  },
]
const TopFilter: React.FC = () => {
  const { data: user } = useGetUser()

  const handleSearch = () => {
    if (!user) {
      notificationController.show({
        description: 'You need to login to access this feature.',
        status: 'error',
      })

      router.push(`${RouteEnum.LOGIN}/?from=${router.pathname}`)
    }
  }
  return (
    <Container className={styles.container}>
      <div className={styles.topFilterWrapper}>
        <div
          style={user ? { width: '20%' } : { width: '100%' }}
          className={styles.inputWrapper}
        >
          <Input
            placeholder="Enter domain, subdomain or URL"
            isFormik={false}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleSearch()
              }
            }}
          />
          <Button size="sm" className={styles.button} onClick={handleSearch}>
            Search
          </Button>
        </div>
        {user && (
          <FlexRow gap="25px" align="center">
            Limit
            <Select options={limitOptions} />
          </FlexRow>
        )}
      </div>
    </Container>
  )
}

export default TopFilter
